const capabilities_request = async (endpoint, service, default_version, reader) => {
    const url = new URL(endpoint);
    console.log(url);
    url.search = new URLSearchParams({
       REQUEST: 'GetCapabilities',
       SERVICE: service,
       VERSION: default_version 
    }).toString();
    
    const response = await fetch(url);
    if( response.status == 200 ) {
        const text = await response.text();

        const result = new reader().read(text);
        return result;    
    } else {
        console.warn("Document not found: ", url, response.status, response.statusText);
    }
    
    
}

export {
    capabilities_request
}